export default "__VITE_ASSET__7d41e75a__"